import { useState } from "react";
import { fetchConversationListService } from "../services/conversationServices";
import { useAuth } from "../context/AuthProvider";
import { useClient } from "../context/ClientsProvider";
import { useQuery } from "@tanstack/react-query";
import { useGlobalContext } from "../context/ConversationsProvider";

const useSidebarHook = () => {
  const [alert, setAlert] = useState(false);
  const auth = useAuth();
  const { selectedClient } = useClient();
  const { dataCheckClientId, isDataCheckComplete } = useGlobalContext();
  const clientId = selectedClient?.id;
  const shouldFetchConversationList = Boolean(
    clientId && isDataCheckComplete && dataCheckClientId === clientId,
  );
  const {
    data: conversationList = [],
    isLoading: isConversationListLoading,
    isFetching: isFetchingConversationList,
  } = useQuery({
    placeholderData: [],
    enabled: shouldFetchConversationList,
    queryKey: ["conversation-list", clientId],
    queryFn: async () => {
      const response = await fetchConversationListService(clientId);
      return response?.active_conversations ?? [];
    },
    staleTime: Infinity,
    refetchOnMount: false,
  });

  const handleLogout = async () => {
    await auth.logout();
  };
  return {
    conversationList,
    isConversationListLoading:
      isConversationListLoading || isFetchingConversationList,
    handleLogout,
    alert,
    setAlert,
  };
};

export default useSidebarHook;
